module.exports = __webpack_public_path__ + "img/partner_4.966b5d95.jpg";